// extracted by mini-css-extract-plugin
var _1 = "TaskTypeField-moduleTaskTypeField__TQWAG";
var _2 = "TaskTypeField-moduletext__FCgqe";
var _3 = "TaskTypeField-moduletextContainer__oxCQj";
export { _1 as "TaskTypeField", _2 as "text", _3 as "textContainer" }
